/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const TableBox = styled.td`
  position: relative;
  padding: 0 0 0 16px;
  max-width: ${({ width }) => `${width}`};

  & > * {
    height: 100%;
    border-right: 1px solid ${Palette.PrimaryGray._200};
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 100%;
`;

export const AppIcon = styled.div`
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: block !important;
  img {
    display: block !important;
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
`;

export const TextBox = styled.div`
  width: ${({ width }) => (width ? width : '100%')};
  padding-right: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const DateParagraph = styled.p`
  display: flex;
  align-items: center;
  color: ${Palette.PrimaryGray._700};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
`;

export const SubRowWrap = styled.div`
  display: flex;
  align-items: center;
  padding-left: 50px;
`;

export const SubRowText = styled.p`
  color: ${Palette.PrimaryGray._700};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-right: 16px;
`;

export const Text = styled.p`
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-right: 16px;
  margin-top: 3px;
`;

export const FlexContainer = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: center;
`;

export const Line = styled.div`
  position: absolute;
  top: 0;
  left: 28px;
  width: 1px;
  height: 100%;
  background-color: ${Palette.PrimaryGray._300};

  &:after {
    content: ' ';
    position: absolute;
    top: 50%;
    left: 0;
    width: 18px;
    height: 1px;
    background-color: ${Palette.PrimaryGray._300};
  }
`;

export const PlacementWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TextWrapper = styled.div`
  padding-left: 45px;
  width: 100%;
  height: auto;
`;
